import * as React from "react";

import { showModal } from "../Component/popups"
import { BaseDialogFormComponent } from "../Component/BaseDialogFormComponent"
import { appContext } from "../App/appContext"
import { navigateToLocalPath } from "../Component/navigation"
import { IRouteComponent } from "../domene"

import { showResetPasswordPopup } from "./ResetPassword"

import Models = Gf.Web.Models;
import { setUrlParam} from "../Component/url";

function login(request: Models.LoginRequest, consumer: (errorMessage: string) => void): void {
    appContext.post("/Login/Login",
        request,
        (response: Models.LoginResponse) => reloadIfNoError(consumer, response.ErrorMessage));
}

function reloadIfNoError(consumer: (errorMessage: string) => void, errorMessage: string) {
    if (!errorMessage) {
        window.location.reload();
    } else {
        consumer(errorMessage);
    }
}

function navigateIfNoError(path: string, consumer: (errorMessage: string) => void, errorMessage: string) {
    if (!errorMessage) {
        navigateToLocalPath(path);
    } else {
        consumer(errorMessage);
    }
}

export function logout(request: Models.LogoutRequest, handler: IRouteComponent | undefined): void {
    if(appContext.visSomAktorId) {
        navigateToLocalPath(setUrlParam(appContext.getCurrentLocation(), "visSom", undefined), false);
    } else {
        appContext.post("/Login/Logout",
            request,
            (response: Models.LogoutResponse) => navigateIfNoError("/", () => {}, response.ErrorMessage));
    }
}

export function showLoginPopup(username: string = "") {
    showModal(<Login Username={username} Password={""} RememberMe={true} />);
}

export class Login extends BaseDialogFormComponent<Models.LoginRequest> {
    constructor(props: Models.LoginRequest) { super(props); }
    title() { 
        return "Logg inn"; 
    }
    body() { 
        return <div>
            {this.field("E-postadresse", "Username", "username")}
            {this.field("Passord", "Password", "password") }
            {this.field("Husk meg", "RememberMe", "checkbox") }
            {this.link("Jeg har ikke logget inn før eller har glemt passordet mitt", () => showResetPasswordPopup(this.state.model))}
        </div>;
    }
    buttons() { 
        return [
            this.button("Avbryt", "button"),
            this.button("Logg inn", "submit", consumer => login(this.state.model, consumer), "primary")
        ];
    }
    requiredFields() { return ["Username", "Password"]; }
}




// WEBPACK FOOTER //
// ./Scripts/React/Login/Login.tsx